import { render, staticRenderFns } from "./NewsBW2026Nagoya.vue?vue&type=template&id=481757bc&scoped=true&"
import script from "./NewsBW2026Nagoya.vue?vue&type=script&lang=js&"
export * from "./NewsBW2026Nagoya.vue?vue&type=script&lang=js&"
import style0 from "./NewsBW2026Nagoya.vue?vue&type=style&index=0&id=481757bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481757bc",
  null
  
)

export default component.exports